<template>
  <div class="rows-per-page">
    <span class="rows-per-page__label">Hiển thị</span>
    <div class="rows-per-page__select-wrapper">
      <select
        :value="value"
        :disabled="disabled"
        class="rows-per-page__select"
        @change="onChange($event.target.value)"
      >
        <option
          v-for="opt in selectOptions"
          :key="opt.value"
          :value="opt.value"
        >
          {{ opt.text }}
        </option>
      </select>
      <span class="rows-per-page__icon">
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
          <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
    <span class="rows-per-page__suffix">dòng</span>
  </div>
</template>

<script>
export default {
  name: 'BillRowsPerPageSelector',
  props: {
    value: {
      type: Number,
      required: true,
    },
    options: {
      type: Array,
      default: () => [
        { value: 10, text: '10' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
      ],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectOptions() {
      return this.options;
    },
  },
  methods: {
    onChange(newValue) {
      const parsed = parseInt(newValue, 10)
      this.$emit('input', parsed)
      this.$emit('change', parsed)
    },
  },
}
</script>

<style scoped>
.rows-per-page {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #64748b;
  user-select: none;
}

.rows-per-page__label,
.rows-per-page__suffix {
  font-weight: 450;
  letter-spacing: -0.01em;
  white-space: nowrap;
}

.rows-per-page__select-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.rows-per-page__select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 6px 28px 6px 12px;
  font-size: 13px;
  font-weight: 500;
  color: #334155;
  cursor: pointer;
  transition: all 0.15s ease;
  min-width: 56px;
  text-align: center;
}

.rows-per-page__select:hover:not(:disabled) {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.rows-per-page__select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.rows-per-page__select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.rows-per-page__icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #94a3b8;
  display: flex;
  align-items: center;
}

.rows-per-page__select:hover:not(:disabled) + .rows-per-page__icon {
  color: #64748b;
}
</style>
